import { immerable } from "immer";
import { DbMongoBaseInfos } from "./db-mongo-base-infos";

import { MetadataFieldBaseTypeEnum } from "./metadata-field-base-type-enum";
import { MetadataFieldValueCardinality } from "./metadata-field-value-cardinality";

export class DbOrderManualTaskTemplateFormFieldInfos extends DbMongoBaseInfos {
  [immerable] = true;
  $type?: any | null | undefined;
  isMandatory: boolean = false;
  baseType: MetadataFieldBaseTypeEnum | null = null;
  valuesCardinality: MetadataFieldValueCardinality | null = null;
  name: string | null = null;
  label: string | null = null;
  values: string[] | null = null;
  predefinedValues: string[] | null = null;

  constructor(init?: Partial<DbOrderManualTaskTemplateFormFieldInfos>) {
    super();
    Object.assign(this, init);
  }
}
